import api from './client';

export const employerAPI = {
  getAllEmployers: async () => {
    const response = await api.get("/employers");
    return response.data;
  },

  getEmployerById: async (id) => {
    const response = await api.get(`/employers/${id}`);
    return response.data;
  },

  createEmployer: async (employerData) => {
    const response = await api.post("/employers", employerData);
    return response.data;
  },

  updateEmployer: async (id, employerData) => {
    const response = await api.put(`/employers/${id}`, employerData);
    return response.data;
  },

  deleteEmployer: async (id) => {
    const response = await api.delete(`/employers/${id}`);
    return response.data;
  },

  getEmployersByStatus: async (status) => {
    const response = await api.get(`/employers/status/${status}`);
    return response.data;
  },

  getSelectedWorkers: async (id) => {
    const response = await api.get(`/employers/${id}/selected-workers`);
    return response.data;
  },

  getStatistics: async (id) => {
    const response = await api.get(`/employers/${id}/statistics`);
    return response.data;
  },

  search: async (params) => {
    const response = await api.get("/employers/search", { params });
    return response.data;
  },

  syncFromEclab: async () => {
    const response = await api.post("/employers/sync-from-eclab");
    return response.data;
  },

  // E-CLAB employer portal helpers
  getApplications: async () => {
    const response = await api.get("/elab/applications");
    return response.data;
  },

  getApplication: async (vdrId) => {
    const response = await api.get(`/elab/applications/${vdrId}`);
    return response.data?.data || response.data;
  },

  getAvailableWorkers: async (vdrId, params = {}) => {
    const response = await api.get(
      `/elab/applications/${vdrId}/available-workers`,
      { params }
    );
    return response.data?.data || response.data;
  },

  getApprovedWorkers: async (params = {}) => {
    const response = await api.get("/elab/employer/approved-workers", {
      params,
    });
    return response.data?.data || response.data;
  },

  createShortlist: async (vdrId, biodataId, options = {}) => {
    const payload = { biodata_id: biodataId, ...options };
    const response = await api.post(
      `/elab/applications/${vdrId}/shortlists`,
      payload
    );
    return response.data;
  },

  releaseShortlist: async (vdrId, shortlistId) => {
    const response = await api.delete(
      `/elab/applications/${vdrId}/shortlists/${shortlistId}`
    );
    return response.data;
  },

  submitSelection: async (vdrId, biodataIds, fclCount) => {
    const response = await api.post(`/elab/applications/${vdrId}/selections`, {
      biodata_ids: biodataIds,
      fcl_count: fclCount ?? biodataIds?.length ?? 0,
    });
    return response.data;
  },

  getSelections: async (vdrId) => {
    const response = await api.get(`/elab/applications/${vdrId}/selections`);
    return response.data?.data || response.data;
  },

  replaceWorker: async (vdrId, applicationWorkerId, newBiodataId) => {
    const response = await api.put(
      `/elab/applications/${vdrId}/workers/${applicationWorkerId}/replace`,
      {
        new_biodata_id: newBiodataId,
      }
    );
    return response.data;
  },

  releaseApprovedWorker: async (applicationWorkerId) => {
    const response = await api.patch(
      `/elab/employer/approved-workers/${applicationWorkerId}`,
      {
        action: "release",
      }
    );
    return response.data;
  },

  getShortlists: async () => {
    const response = await api.get("/employer/shortlists");
    return response.data;
  },

  submitShortlistBatch: async (payload) => {
    const response = await api.post("/elab/applications/submit", payload);
    return response.data;
  },

  // Special Quota (eQuotaSpecial) helpers
  getSpecialQuotas: async (params = {}) => {
    const response = await api.get("/special-quotas", { params });
    return response.data?.data || response.data;
  },

  getSpecialQuota: async (vdrId) => {
    const response = await api.get(`/special-quotas/${vdrId}`);
    return response.data?.data || response.data;
  },

  createSpecialQuota: async (payload) => {
    const response = await api.post("/special-quotas", payload);
    return response.data;
  },

  submitSpecialQuota: async (id) => {
    const response = await api.post(`/special-quotas/${id}/submit`);
    return response.data;
  },

  uploadSpecialQuotaSlip: async (file) => {
    const formData = new FormData();
    formData.append("file", file);
    const response = await api.post("/special-quotas/upload-slip", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  },
};

// Admin/Master Admin Special Quota review APIs
